import CaseEvents from './Case.events';
import TemplateEvents from './Template.events';
import ReportPresetEvents from './ReportPreset.events';
import AIEvents from './AI.events';
import EpisodeEvents from './Episode.events';
import CalendarEvents from './Calendar.events';
import BillingAndSubscriptionsEvents from './BillingAndSubscriptions.events';

const MixpanelEvents = {
  ...CaseEvents,
  ...TemplateEvents,
  ...ReportPresetEvents,
  ...AIEvents,
  ...EpisodeEvents,
  ...CalendarEvents,
  ...BillingAndSubscriptionsEvents
};

export default MixpanelEvents;
